import React, {useEffect, useState} from 'react';
import {PasswordSource} from '@store/password/PasswordSource';
import {browserHistory} from 'react-router';
import {PasswordWelcomeForm} from '@components/password/PasswordWelcomeForm';

interface PasswordWelcomeContainerProps {
  routeParams: {code: string} | undefined;
}

export const PasswordWelcomeContainer: React.FC<PasswordWelcomeContainerProps> = ({
  routeParams,
}) => {
  const code = routeParams && routeParams['code'];
  // Code failed validation.
  const [badCode, setBadCode] = useState<boolean>(false);
  // Unexpected code validation error.
  const [error, setError] = useState<boolean>(false);
  // Validation response.
  const [firstName, setFirstName] = useState<string>('');
  const [hasPassword, setHasPassword] = useState<boolean>(false);

  // Validate the code. This will tell us if it is bad.
  useEffect(() => {
    if (code) {
      PasswordSource.validateResetCode(code)
        .then(r => {
          setFirstName(r.firstName);
          setHasPassword(r.hasPassword);
        })
        .catch(e => {
          if (e.response.status === 404) {
            setBadCode(true);
          } else {
            console.error('Unexpected error', e);
            setError(true);
          }
        });
    }
  }, [code]);

  // If the code is bad, go to the expired page. If user's already set up a password, go to the login screen.
  useEffect(() => {
    if (badCode) {
      // redirect to expired link page
      browserHistory.push('/expired/link');
    } else if (hasPassword) {
      // redirect to login. user's already done the setup.
      browserHistory.push('/login');
    }
  }, [badCode, hasPassword]);

  // Otherwise, render the page.
  if (error) {
    return <div>There was an error processing your request. Please try again later.</div>;
  }
  if (code) {
    return <PasswordWelcomeForm code={code} firstName={firstName} />;
  }
  return null; // router config requires a code, so this shouldn't happen.
};
